var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plane-line",
    clipPath: "url(#clip0_1205_57204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5538 9.83333L7.1579 15.1667L5.81378 15.1667L7.51141 9.83333L3.90915 9.83333L2.7895 11.8333L1.7814 11.8333L2.45346 8.83333L1.7814 5.83333L2.7895 5.83333L3.90982 7.83333L7.51208 7.83333L5.81378 2.5L7.1579 2.5L10.5538 7.83333L14.2146 7.83333C14.4819 7.83333 14.7383 7.93869 14.9274 8.12623C15.1164 8.31376 15.2227 8.56812 15.2227 8.83333C15.2227 9.09855 15.1164 9.3529 14.9274 9.54044C14.7383 9.72798 14.4819 9.83333 14.2146 9.83333L10.5538 9.83333Z",
    fill: "#D0D5DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_57204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.1295,
    fill: "white",
    transform: "translate(16.5664 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneLine);
export default __webpack_public_path__ + "static/media/plane-line.5d9d4061096753c32b562e8ed0bf375c.svg";
export { ForwardRef as ReactComponent };